import React, { Component } from "react";
import { connect } from "react-redux";
import Highcharts from 'highcharts';
import '../../../../../Assets/EnsembleStyles/WorkOrderReport.css';
import { GetWorkorderList, GetClosedWorkorderList } from "../../../../../action/workorderAction";
import LoadingIndicator from "../../../Common/LoadingIndicator";

let problems_in_Select_input = [];
let WorkOrderList = [], WorkOrderClosedList = [];
class WOPieChart extends Component {

    async componentDidMount(){

        if(this.props.WorkOrderList !== null && this.props.WorkOrderList !== undefined){
            WorkOrderList = this.props.WorkOrderList;
            if(this.props.WorkOrderClosedList !== null && this.props.WorkOrderClosedList !== undefined){
                WorkOrderClosedList = this.props.WorkOrderClosedList; 
                this.FormHighchartsdata();
            }
            else{
                this.props.GetClosedWorkorderList().then(() => {
                   WorkOrderClosedList = this.props.getWorkorderList.ClosedWorkOrderList;
                   this.FormHighchartsdata();             
                });
            }
                    
        }

      else{

        this.props.GetWorkorderList().then(() => {
            WorkOrderList = this.props.getWorkorderList.WorkOrderList;
            this.props.GetClosedWorkorderList().then(() => {
               WorkOrderClosedList = this.props.getWorkorderList.ClosedWorkOrderList;             
               this.FormHighchartsdata();       
            });
        });
       }

        
    }

    async FormHighchartsdata()
    {
        this.setState({isloading: false}); 
        const lSeriesChartData = this.FormingPieChartData("-1");
        await Promise.all([lSeriesChartData])
        var lseries = [{
            name: 'Problems',
            data: lSeriesChartData
        }];
        this.highChartsRender(lseries);
        this.setState({ series : lseries}); 
    }

    highChartsRender(lseries) {
        Highcharts.chart({
            chart: {
              type: 'pie',
              renderTo: 'atmospheric-composition'
            },
            title: {
              verticalAlign: 'middle',
              floating: true,
              text: '',
              style: {
                fontSize: '10px',
              }
            },
            plotOptions: {
              pie: {
                dataLabels: {
                    crop: true,
                    useHTML: true,
                    format: '{point.name}:{point.percentage:.1f} %'
                }
              }
            },
            tooltip: {
                style: {
                    color: '#000000',
                    fontSize: '12px',
                    fontWeight: 'bold'
                },
                useHTML: true,
                pointFormat: 'count: {point.count}'
            },
            series: lseries
        });
        if(document.getElementsByClassName('highcharts-credits')[0] !== undefined)
            document.getElementsByClassName('highcharts-credits')[0].style.display = "none"
    }

    FormingPieChartData(lFilterId){
        let lSeriesChartData = [], lWorkOrders = [];
        if(WorkOrderList !== null && WorkOrderList !== undefined){
           WorkOrderList.forEach(el => {
               lWorkOrders.push(el);
           })
        };
        if(WorkOrderClosedList !== null && WorkOrderClosedList !== undefined){
            WorkOrderClosedList.forEach(el => {
                lWorkOrders.push(el);
            })
        };
        if(lWorkOrders !== undefined && lWorkOrders !== null && lWorkOrders.length){
            var data = lFilterId !== "-1" ? lWorkOrders.filter(x => x.status === Number(lFilterId)) : lWorkOrders; 
            var lSeriesData = [], lTotalPblms = 0;
            problems_in_Select_input.forEach(ele =>{
                var SelectedData = data.filter(x => x.workOrderDetail.problemID === ele.ProblemId); 
                lSeriesData.push({"ProblemId":ele.ProblemId,"Problem":ele.Problem,"Count":SelectedData.length});
                lTotalPblms = lTotalPblms + SelectedData.length;
            })
            
            if(lSeriesData !== undefined && lSeriesData !== null && lSeriesData.length){
                lSeriesData.forEach(ele =>{
                    if(ele.Count !== 0){
                        var Percentage = ((ele.Count / lTotalPblms) * 100).toFixed(1);
                        lSeriesChartData.push({"name":ele.Problem, "y": Number(Percentage), "count":ele.Count});
                    }
                })
            }
        }
        return lSeriesChartData;
    }

    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            StatusFilterValue: -1,
            series: [{
                name: 'Problems',
                data: []
            }]
        };
        this.OnSort = this.OnSort.bind(this);
        this.OnStatusFilterChange = this.OnStatusFilterChange.bind(this);
    }

    OnSort(values) {
        if (values !== undefined && values !== null && values !== "--") {
            const sorted_data = values.sort((a, b) => {
                let nameA, nameB;
                nameA = a.orderId;
                nameB = b.orderId;
                return (nameA - nameB);
            });
            return sorted_data;
        }
    }

    OnStatusFilterChange() {
        var selectedOption = this.refs.status_filter_in_Select_input.options.selectedIndex;
        var lFilterId = this.refs.status_filter_in_Select_input.options[selectedOption].id;
        
        var lSeriesChartData = this.FormingPieChartData(lFilterId);
        var lseries = [{
            name: 'Problems',
            data: lSeriesChartData
        }]
        this.highChartsRender(lseries);
        this.setState({ StatusFilterValue : lFilterId });
    }

    render() {
        let label = this.props.getLabels;
        
        let preferredfields = this.props.getWorkorderPreferences;
        let Status_Filters_in_Select_input = [];

        var status = (preferredfields !== "" && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Status" && x.display === true) : "";
        var Status = label['WorkOrders.Status.Text'].split(',');
        if (status.length > 0) {
            if (status[0].value.length > 0) {
                var status_values = this.OnSort(status[0].value);
                Status_Filters_in_Select_input = status_values.map(el => (
                    <option id={el.key} key={el.key} value={el.key}>{el.value}</option>
                ));
            }
            else {
                Status_Filters_in_Select_input = Status.map(el => (
                    <option id={el} key={el} value={el}>{label['WorkOrders.Status.' + el + '.Text']}</option>
                ));
            }
        }

        var problem = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Problem" && x.display === true) : "";
        var Problems = label['WorkOrders.Problem.Text'].split(',');
        problems_in_Select_input = [];
        if (problem.length > 0) {
            if (problem[0].value.length > 0) {
                var problem_values = this.OnSort(problem[0].value);
                problem_values.forEach(el =>{
                    problems_in_Select_input.push({"ProblemId":el.key,"Problem":el.value});
                });
            }
            else {
                Problems.forEach(el =>{
                    problems_in_Select_input.push({"ProblemId":el,"Problem":label['WorkOrders.Problem.' + el + '.Text']});
                });
            }
        }

        return (
            <div className="main_container box_border">
                <label className={this.props.ForEquipment ? "workOrderlabel" : ""} style={{ fontFamily: 'lato', fontSize: '15px', fontWeight: 'bold', color: 'black' }}>Work Order Problems by Status</label><br />
                <select ref='status_filter_in_Select_input' style={{ "margin-top": "10px", "width": "213px" }} className="pmminimal pm-dropdown" value={this.state.StatusFilterValue} onChange={this.OnStatusFilterChange}>
                    <option id="-1">All</option>
                    {Status_Filters_in_Select_input}
                </select>
                {(this.state.isloading)? <div style={{position:'absolute', top:'50%', left:'40%'}}><LoadingIndicator/></div> : <div id="atmospheric-composition" style={{"margin-left":"-15px","margin-right":"-15px"}}></div>}
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails,
        getWorkorderList: state.WorkorderRootReducer
    };
};
const mapDispatchToProps = dispatch => {
    return {
        GetWorkorderList: () => dispatch(GetWorkorderList()),
        GetClosedWorkorderList: () => dispatch(GetClosedWorkorderList())
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WOPieChart);